export enum AdminRoutes {
  EMPTY = '',
  DASHBOARD = 'dashboard',
  PROJECTS = 'projects',
  PROJECT_TYPES = 'project-types',
  PEOPLE = 'people',
  MESSAGES = 'messages',
  EVENTS = 'events',
}
